/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useInfoModal } from '../info-modal/Hooks';
import { navigation } from '@ecosystem/newron-design-system';
import { capitalizeEachWord } from '@utils/StringUtils';
import { uniq } from 'lodash';

interface Props {
  periodValue: string;
  unavailablePgs: string[];
}
export type PgAvailabilityProps = {
  text: string;
  periodValue: string;
  unavailablePgs: string[];
};

const formatGrammarForUnavailablePgs = (periodValue: string, unavailablePgs: string[]): string => {
  return `Some ${periodValue} data is not available yet. For more product categories try an earlier time frame. ${
    unavailablePgs.length > 1 ? 'Product groups' : 'Product group'
  } that ${unavailablePgs.length > 1 ? 'are' : 'is'} not part of the total ${
    unavailablePgs.length > 1 ? 'are' : 'is'
  }:`;
};

const PgAvailabilityInfo: React.FC<Props> = ({ periodValue, unavailablePgs }) => (
  <section>
    <p>
      {formatGrammarForUnavailablePgs(periodValue, unavailablePgs)}
      <br></br>
      <br></br>
      {unavailablePgs.map(capitalizeEachWord).join(', ')}
    </p>
  </section>
);

const PgAvailability: React.FC<PgAvailabilityProps> = ({ text, periodValue, unavailablePgs }) => {
  const showInfoModal = useInfoModal();
  const unavailablePgsSet = uniq(unavailablePgs);

  const [data, setData] = useState({
    isVisible: false,
    message: '',
  });

  const onClick = () => {
    showInfoModal(
      'Partial data load',
      <PgAvailabilityInfo periodValue={periodValue} unavailablePgs={unavailablePgsSet} />,
    );
  };

  useEffect(() => {
    if (periodValue) {
      setData({
        isVisible: true,
        message: text,
      });
    }
  }, [periodValue, text]);

  return data.isVisible ? (
    <div data-test-id="pg-warning">
      <span data-test-id="pg-message">{data.message}</span>
      <navigation.Link data-test-id="pg-unavailable-link" onClick={onClick}>
        Learn more
      </navigation.Link>
    </div>
  ) : null;
};

export default PgAvailability;
